<template>
  <el-table-column
    v-bind="$attrs"
    header-align="center"
    align="left"
    :label="$t('api.user.fields.auth_id_and_email.label')"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-tooltip
        v-if="scope.row.email !== ''"
        class="item"
        effect="dark"
        placement="left"
        :content="$t('api.user.fields.email.label')"
        >
        <el-tag
          :disable-transitions="true"
          class="allow-click-copy"
          @click="doCopy(scope.row.email)"
          effect="plain"
          >
          <i class="el-icon-message"></i>
          <span>{{ scope.row.email }}</span>
        </el-tag>
      </el-tooltip>
      <div
        v-for="authData in scope.row.auth"
        :key="authData.id"
        >
        <el-tooltip
          class="item"
          effect="dark"
          placement="left"
          :content="$t('api.user.fields.auth_id.label')"
          >
          <el-tag
            :disable-transitions="true"
            class="allow-click-copy"
            @click="doCopy(authData.auth_id)"
            effect="plain"
            type="info"
            >
            <span>
              <i class="el-icon-key"></i>
              <span class="authType">
                {{ getAuthType(authData.auth_type) }}
              </span>
              {{ authData.auth_id }}
            </span>
          </el-tag>
        </el-tooltip>
      </div>
    </template>
  </el-table-column>
</template>

<script>

import { getMap } from '@/utils/i18n'
import { doCopy } from '@/utils/copy'

export default {
  name: 'user-email-field',
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    getMap,
    doCopy,
    getAuthType (t) {
      var authType = this.getMap('authType').filter(function (el) {
        return el.value === t
      })
      return (authType[0]) ? authType[0].label : '?'
    }
  }
}
</script>
